
import request from "@/utils/request";

export function equipDetailApi (params) {
  return request({
    url: "?c=em&a=equip&do=detail",
    method: "get",
    params
  })
}

export function equipMonitorApi (params) {
  return request({
    url: "?c=em&a=equip&do=monitor",
    method: "get",
    params
  })
}

export function equipAnalysisApi (params) {
  return request({
    url: "?c=em&a=effectiveness&do=get",
    method: "get",
    params
  })
}
